import { render, staticRenderFns } from "./AppSmartBanner.vue?vue&type=template&id=77b20789&scoped=true"
import script from "./AppSmartBanner.vue?vue&type=script&lang=ts"
export * from "./AppSmartBanner.vue?vue&type=script&lang=ts"
import style0 from "./AppSmartBanner.vue?vue&type=style&index=0&id=77b20789&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b20789",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseBtn: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseBtn.vue').default})
